import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getPostById, updatePost } from '../utils/storage';
import { getCurrentUser } from '../utils/auth';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './auth.css';

export default function EditPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [error, setError] = useState('');
  const [preview, setPreview] = useState(false);

  useEffect(() => {
    const p = getPostById(id);
    if (!p) {
      setError('未找到文章');
      return;
    }
    setPost(p);
    setTitle(p.title || '');
    setContent(p.content || '');
  }, [id]);

  useEffect(() => {
    if (!post) return;
    const user = getCurrentUser();
    if (!user || user.username !== post.author) {
      setError('无权限编辑此文章');
    }
  }, [post]);

  function onSubmit(e) {
    e.preventDefault();
    if (!title.trim() || !content.trim()) {
      setError('请填写标题与内容');
      return;
    }
    const ok = updatePost(id, { title: title.trim(), content: content.trim() });
    if (!ok) {
      setError('更新失败');
      return;
    }
    navigate(`/post/${id}`);
  }

  if (error) {
    return (
      <div className="container">
        <h2>{error}</h2>
      </div>
    );
  }

  if (!post) return null;

  return (
    <div className="container">
      <h1>编辑文章</h1>
      <form className="editor" onSubmit={onSubmit}>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="标题" />
        <textarea value={content} onChange={e => setContent(e.target.value)} placeholder="正文（支持 Markdown）" rows={12} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="checkbox" checked={preview} onChange={e => setPreview(e.target.checked)} /> 预览
          </label>
          <div className="editor-actions">
            <button className="btn" type="submit">保存</button>
          </div>
        </div>
      </form>

      {preview && (
        <div style={{ marginTop: 18, background: '#fff', padding: 16, borderRadius: 10 }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      )}
    </div>
  );
}
